export const ecgPreferenceKey = 'ghs.ecgEnabled';

export const listOptions = {
    initialStartIndex: 1,
    pageSize: 20,
    startTimeOfEcg: '2021-01-01',
    loadingTypes: {
        fetchInitial: 'fetchInitial',
        reloadTable: 'reloadTable',
        fetchMore: 'fetchMore'
    }
};
export const NR_OF_ECG_CHARTS = 3;

export const ecgRecordingsInconclusiveKeys = [
    'INCONCLUSIVE_POOR_SIGNAL',
    'INCONCLUSIVE_SR_WITH_HR_100_TO_120',
    'INCONCLUSIVE_OTHER'
];

export const ecgRecordingsHighAndLowHRKeys = ['INCONCLUSIVE_HR_UNDER_50', 'INCONCLUSIVE_HR_OVER_120_50'];

export const ecgRecordingTypes = {
    SINUS_NORMAL: 'SINUS_NORMAL',
    AFIB: 'AFIB',
    INCONCLUSIVE_POOR_SIGNAL: 'INCONCLUSIVE_POOR_SIGNAL',
    INCONCLUSIVE_HR_UNDER_50: 'INCONCLUSIVE_HR_UNDER_50',
    INCONCLUSIVE_HR_OVER_120_50: 'INCONCLUSIVE_HR_OVER_120_50',
    INCONCLUSIVE_SR_WITH_HR_100_TO_120: 'INCONCLUSIVE_SR_WITH_HR_100_TO_120',
    INCONCLUSIVE_OTHER: 'INCONCLUSIVE_OTHER',
    INVALID: 'INVALID'
};

export const VIDEO_URL = 'https://connectvideo.garmin.com/2bf4f409/10af7233-877a-44ff-9a81-e18260e64a20.mp4';

export const ecgFilterTypes = {
    SYMPTOMS: {
        type: 'SYMPTOMS',
        translationNsAndKey: 'ecg:ecg_symptom'
    },
    RESULT: {
        type: 'RESULT',
        translationNsAndKey: 'ecg:ecg_result'
    },
    DATE: {
        type: 'DATE',
        translationNsAndKey: 'common:date'
    }
};

export const ecgSymptomTypes = {
    RAPID_HEARTBEAT: 'RAPID_HEARTBEAT',
    SKIPPED_HEARTBEAT: 'SKIPPED_HEARTBEAT',
    FATIGUE: 'FATIGUE',
    SHORTNESS_OF_BREATH: 'SHORTNESS_OF_BREATH',
    CHEST_TIGHTNESS: 'CHEST_TIGHTNESS',
    FAINTING: 'FAINTING',
    DIZZINESS: 'DIZZINESS',
    OTHER: 'OTHER',
    NO_SYMPTOMS: 'NO_SYMPTOMS',
    NO_SELECTION: 'NO_SELECTION'
};

export const ecgResultTypes = {
    SINUS_NORMAL: [ecgRecordingTypes.SINUS_NORMAL],
    AFIB: [ecgRecordingTypes.AFIB],
    INCONCLUSIVE_HR_OVER_120_50: [ecgRecordingTypes.INCONCLUSIVE_HR_OVER_120_50],
    INCONCLUSIVE_HR_UNDER_50: [ecgRecordingTypes.INCONCLUSIVE_HR_UNDER_50],
    INCONCLUSIVE: [
        ecgRecordingTypes.INCONCLUSIVE_POOR_SIGNAL,
        ecgRecordingTypes.INCONCLUSIVE_SR_WITH_HR_100_TO_120,
        ecgRecordingTypes.INCONCLUSIVE_OTHER
    ]
};
